import React from 'react';
import { XIcon } from 'lucide-react';
export function HardClaims() {
  const missingElements = ['Structured governance', 'Measured revision impact', 'CRM-level attribution', 'Controlled prompt systems'];
  return <section className="w-full py-16 md:py-24 px-4" data-id="element-66">
      <div className="container max-w-4xl mx-auto text-center" data-id="element-67">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground mb-8 leading-tight" data-id="element-68">
          Built for Teams That Run Marketing Like Operations
        </h2>

        <div className="bg-card rounded-2xl p-8 md:p-12 border border-border shadow-sm mb-8" data-id="element-69">
          <p className="text-lg text-muted-foreground mb-6 leading-relaxed" data-id="element-70">
            If you're producing content without:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" data-id="element-71">
            {missingElements.map((element, index) => <div key={index} className="flex items-center gap-3 p-4 rounded-lg bg-muted/50" data-id="element-72">
                <XIcon className="h-5 w-5 text-destructive flex-shrink-0" aria-hidden="true" data-id="element-73" />
                <span className="text-base text-foreground font-medium" data-id="element-74">
                  {element}
                </span>
              </div>)}
          </div>

          <p className="text-xl font-semibold text-muted-foreground leading-relaxed" data-id="element-75">
            You're running experiments — not infrastructure.
          </p>
        </div>

        <p className="text-2xl font-bold text-foreground leading-relaxed" data-id="element-76">
          WisePilot installs operational discipline into AI-driven marketing.
        </p>
      </div>
    </section>;
}